import React, { useEffect } from "react";
import { List } from "@mui/material";
import { connect } from "react-redux";
import { getApplicationCodes } from "../../reducers";
import { getApplications } from "../../actions/oauthActions";

import PORTMenu from "../Applications/PORT/PORTMenu";
import JPMenu from "../Applications/JP/JPMenu";
import MSFMenu from "../Applications/MSF/MSFMenu";
import LRSMenu from "../Applications/LRS/LRSMenu";
import TMSMenu from "../Applications/TMS/TMSMenu";
import RMSMenu from "../Applications/RMS/RMSMenu";
import RSMenu from "../Applications/RS/RSMenu";
import CENTMenu from "../Applications/CENT/CENTMenu";
import X360Menu from "../Applications/X360/X360Menu";

const ApplicationsMenu = ({ applicationCodes = [], getApplications }) => {
    useEffect(() => {
        getApplications();
    }, [getApplications]);

    const hasPRMSD = applicationCodes.includes("P-RMSD");
    const hasPRMSN = applicationCodes.includes("P-RMSN");
    const hasZRS = applicationCodes.includes("Z-RS");
    const hasPJP = applicationCodes.includes("P-JP");
    const hasZJP = applicationCodes.includes("Z-JP");
    const hasPMSF = applicationCodes.includes("P-MSF");
    const hasCMSF = applicationCodes.includes("C-MSF");
    const hasEMSF = applicationCodes.includes("E-MSF");
    const hasCTMS = applicationCodes.includes("C-TMS");
    const hasCLRS = applicationCodes.includes("C-LRS");
    const hasPCPD = applicationCodes.includes("P-CPD");
    const hasCPORT = applicationCodes.includes("C-PORT");
    const hasX360 = applicationCodes.includes("X-E360");

    const hasCENT = hasPRMSD || hasPRMSN || hasPCPD;

    return (
        <List
            className="menu-list-root"
            component="nav"
            aria-label="Application menu"
        >
            {(hasPRMSD || hasPRMSN) && <RMSMenu />}
            {hasZRS && <RSMenu />}
            {(hasPJP || hasZJP) && <JPMenu />}
            {(hasPMSF || hasCMSF || hasEMSF) && <MSFMenu />}
            {hasX360 && <X360Menu />}
            {hasCTMS && <TMSMenu />}
            {hasCLRS && <LRSMenu />}
            {(hasPRMSD || hasPRMSN || hasPCPD || hasCPORT) && <PORTMenu />}
            {hasCENT && <CENTMenu />}
        </List>
    );
};

const mapStateToProps = (state) => ({
    applicationCodes: getApplicationCodes(state),
});

export default connect(mapStateToProps, { getApplications })(ApplicationsMenu);
